import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { LIVE } from '../../../utils/constants';
import { ACTIVE, ARCHIVE, PLAN } from '../utils/constants';

export const useToggleStatus = ({ postStatus, tileStatus }) => {
  const { t } = useTranslation('tiles');
  const archiveToggle = postStatus === LIVE ? ACTIVE : PLAN;

  const status = {
    active: {
      toggle: ARCHIVE,
      toggleText: t('tileCardMenu.hide'),
      toggleIcon: <HideIcon />,
    },
    archive: {
      toggle: archiveToggle,
      toggleText: t('tileCardMenu.unhide'),
      toggleIcon: <UnhideIcon />,
    },
    plan: {
      toggle: ARCHIVE,
      toggleText: t('tileCardMenu.hide'),
      toggleIcon: <HideIcon />,
    },
  };

  const canToggle = [ACTIVE, ARCHIVE, PLAN];
  const { toggle, toggleText, toggleIcon } = status[tileStatus] || {};

  return { toggle, toggleText, toggleIcon, canToggle };
};

const HideIcon = styled.i.attrs({
  className: 'fa-regular fa-eye',
})`
  margin-right: 5px;
`;

const UnhideIcon = styled.i.attrs({
  className: 'fa-regular fa-eye-slash',
})`
  margin-right: 5px;
`;
